import * as React from "react";
import { Box, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { usePageLayout } from "../GeneralLayout";

interface RightDrawerProps {
  drawerContent: React.ReactNode;
  width?: number;
  topOffset?: number;
  bottomOffset?: number;
}

export default function RightDrawer({
  drawerContent,
  width = 300,
  topOffset = 0,
  bottomOffset = 0,
}: RightDrawerProps) {
  const theme = useTheme();
  const { openRight, toggleRight } = usePageLayout();

  return (
    <Box
      sx={{
        position: "absolute",
        top: topOffset,
        bottom: bottomOffset,
        right: 0,
        width: openRight ? `${width}px` : "50px",
        bgcolor: theme.custom.ui.drawers.right.dark,
        color: theme.custom.base.text.primary.dark,
        transition: "width 0.3s ease",
        display: "flex",
        flexDirection: "column",
        zIndex: 5,
        boxShadow: 2,
      }}
    >
      <IconButton
        onClick={toggleRight}
        sx={{ alignSelf: "flex-start", color: theme.custom.base.text.primary.dark }}
      >
        {openRight ? <ChevronRight /> : <ChevronLeft />}
      </IconButton>
      {openRight && <Box sx={{ flex: 1, p: 1, overflowY: "auto" }}>{drawerContent}</Box>}
    </Box>
  );
}
